import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import BaseInput from "../base-input";
import { _, pick, DateType, TimeType } from "../../model/utils";
import {
  setNumTableGuests,
  setTableDate,
  setTableTime
} from "../../store/actions";
import "./styles.css";
import SelectDateRange from "../date-and-time/select-date-range";
import moment from "moment";

const mapStateToProps = pick(["numTableGuests", "tableDate", "tableTime"]);

const mapDispatchToProps = dispatch => ({
  setNumTableGuests: value => dispatch(setNumTableGuests(parseInt(value, 10))),
  setTableDate: value => dispatch(setTableDate(value)),
  setTableTime: value => dispatch(setTableTime(value))
});

function TableDataForm({
  numTableGuests,
  setNumTableGuests,
  tableDate,
  setTableDate,
  tableTime,
  setTableTime
}) {
  return (
    <div styleName="container">
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-3">
          <BaseInput
            fieldName="table_guests"
            placeholder={_.numGuests}
            value={"" + numTableGuests}
            setValue={setNumTableGuests}
            type="number"
            error={""}
            min={1}
          />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-9">
          <SelectDateRange
            fieldName="table_day"
            label={_.tableDate}
            isDateRange={false}
            date={tableDate}
            setDate={setTableDate}
            time={tableTime}
            setTime={setTableTime}
            allowedDateRanges={[[moment(), moment().add(365, "days")]]}
            timeData={{
              allowedTimes: [
                [12, 0],
                [12, 15],
                [12, 30],
                [12, 45],
                [13, 0],
                [13, 15],
                [13, 30],
                [13, 45],
                [14, 0],
                [14, 15],
                [14, 30],
                [19, 0],
                [19, 15],
                [19, 30],
                [19, 45],
                [20, 0],
                [20, 15],
                [20, 30],
                [20, 45],
                [21, 0],
                [21, 15],
                [21, 30],
                [21, 45]
              ],
              minMorningTime: [9, 0],
              maxMorningTime: [15, 0],
              minAfternoonTime: [18, 0],
              maxAfternoonTime: [23, 0],
              timeStep: 15
            }}
          />
        </div>
      </div>
    </div>
  );
}

TableDataForm.propTypes = {
  numTableGuests: PropTypes.number.isRequired,
  setNumTableGuests: PropTypes.func.isRequired,
  tableDate: DateType,
  setTableDate: PropTypes.func.isRequired,
  tableTime: TimeType,
  setTableTime: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableDataForm);
